import React from "react";
import "./404.scss";

const NotFound404 = () => {
  return (
    <>
      <div className="container-404 mx-auto p-4 flex flex-col w-[80vw] h-[100vh] font-sans">
        <div className="flex flex-col w-full h-full justify-center container-md text-left float-left max-w-xl">
          <h1 className="text-[50px] my-2 font-bold text-blue-500">404</h1>
          <h2 className="text-[20px] my-2 font-bold text-black">
            Oops! You weren&apos;t supposed to see this
          </h2>
          <p className="my-2 text-gray-400">
            The page you&apos;re looking for no longer exists.
          </p>
        </div>
      </div>
    </>
  );
};

export default NotFound404;
